import React from 'react';
import omit from 'lodash/omit';
import LabelledInput from './LabelledInput';

const withLabel = (InputComponent) => {
  const LabeledInput = ({
    label,
    tooltipID,
    tooltip,
    disableTooltip,
    valid,
    error,
    controlId,
    name,
    ...inputProps
  }) => (
    <LabelledInput
      label={label}
      tooltipID={tooltipID}
      tooltip={tooltip}
      disableTooltip={disableTooltip}
      valid={valid}
      error={error}
      controlId={`${controlId}`}
    >
      <InputComponent id={name} {...inputProps} />
    </LabelledInput>
  );

  LabeledInput.propTypes = {
    ...omit(LabelledInput.propTypes, 'children'),
    ...InputComponent.propTypes,
  };

  LabeledInput.defaultProps = {
    ...LabelledInput.defaultProps,
    ...InputComponent.defaultProps,
  };

  return LabeledInput;
};

export default withLabel;
